module.exports = __webpack_public_path__ + "img/peek.4680bca9.jpg";